import React, { useState } from "react"
import {
  Box,
  Text,
  Heading,
  Link,
  Flex,
  Stat,
  Container
} from "@chakra-ui/react"
import styles from "../../styles/solutions.module.css"
import Meta from "../../components/meta/Meta"
import ModalIframe from "../../components/modalIframe/ModalIframe"
import { SUBSCRIBE_URL } from "../../utils/Constants"

import PrimaryButton from "../../components/buttons/PrimaryButton"
import NextLink from "next/link"

import YouTube from "react-youtube"

export default function GetStarted() {
  const [subscribeModalShow, setSubscribeModalShow] = useState(false)

  const [iframeUrl, setIframeUrl] = useState("")

  const [height, setHeight] = useState("480px")

  const [heading, setHeading] = useState("")

  const subscribeModalToggle = (url, heading, height) => {
    setIframeUrl(url)
    setHeading(heading)
    setHeight(height)
    setSubscribeModalShow(!subscribeModalShow)
  }
  const src = "k5Q6HO_HX6g"
  const opts = {
    height: "400",
    width: "100%",
    playerVars: {
      autoplay: 0,
      rel: 0,
    },
  }

  function ButtonClick() {}

  return (
    <>
      <Meta
        pageName={
          "TrackSellers.com - The Ultimate Amazon Seller Directory"
        }
        description={
          "Leverage TrackSellers comprehensive database of 5 million Amazon sellers, explore rich seller profiles, generate targeted leads, and forge strategic partnerships to supercharge your e-commerce success."
        }
        hrefLink={"https://www.tracksellers.com/get-started"}
      />
      <Box className={styles.ReportMainBox}>
        <Container maxW="container.xl">
          <Box pb="1rem">
            <Box className={styles.ReportSubBox}>
              <Heading as={"h1"} mb="18px" className={styles.ReportHead}>
                TrackSellers.com - The Ultimate Amazon Seller Directory
              </Heading>
            </Box>
          </Box>
          <Box>
            <Box>
              <Flex
                flexDir={{ base: "column", md: "row", lg: "row" }}
                alignItems="center"
                margin="0 auto"
                padding="20px"
              >
                <Box flex marginBottom={{ base: "2rem", md: 1 }}>
                  <Box width="100%" maxWidth="740px">
                    <YouTube videoId={src} opts={opts} width="100%" />
                  </Box>
                  <Text
                    color="grey"
                    fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }}
                    fontWeight="400"
                    width="100%"
                    marginTop="1rem"
                  >
                    Leverage TrackSellers comprehensive database of 5 million
                    Amazon sellers, explore rich seller profiles, generate
                    targeted leads, and forge strategic partnerships to
                    supercharge your e-commerce success.
                  </Text>
                </Box>

                <Box flex sx={{ ml: "2em" }} width="100%" maxWidth="450px">
                  <iframe
                    title="Calendly"
                    src="https://calendly.com/tracks/30min"
                    width="100%"
                    height="500"
                    frameBorder="0"
                  />
                </Box>
              </Flex>
            </Box>
          </Box>
          <Box>
            <Stat me="auto">
              <Box mt="1.5rem">
                <Box mt="5rem" mb="2rem" sx={{ textAlign: "center" }}>
                  <Heading
                    color="#243e63"
                    fontSize={{
                      base: "1rem",
                      md: "1.5rem",
                      lg: "1.5rem",
                    }}
                    mb="15px"
                  >
                   Explore our pricing to find the perfect plan for your needs
                  </Heading>
                </Box>
                <Box mt="2rem" mb="2rem" textAlign="center">
                  <NextLink href={"/pricing"} passHref>
                    <Link>
                      <PrimaryButton
                        ButtonClick={ButtonClick}
                        buttonName="PRICING"
                      />
                    </Link>
                  </NextLink>
                </Box>
                <Box mt="5rem" mb="2rem" sx={{ textAlign: "center" }}>
                  <Heading
                    color="#243e63"
                    fontSize={{
                      base: "1rem",
                      md: "1.5rem",
                      lg: "1.5rem",
                    }}
                    mb="15px"
                  >
                    Subscribe to gain actionable insights to bolster your services and solutions
                  </Heading>
                </Box>
                <Box mt="2rem" mb="2rem" textAlign="center">
                  <Link>
                    <PrimaryButton
                      ButtonClick={() =>
                        subscribeModalToggle(
                          SUBSCRIBE_URL,
                          "Subscribe to",
                          "480px"
                        )
                      }
                      buttonName="Subscribe"
                    />
                  </Link>
                </Box>
              </Box>
            </Stat>
          </Box>
          <ModalIframe
            show={subscribeModalShow}
            close={subscribeModalToggle}
            heading={heading}
            iframeUrl={iframeUrl}
            height={height}
          />
        </Container>
      </Box>
    </>
  )
}
